import { Stack } from "@mui/material";
import { type Control, Controller } from "react-hook-form";
import { DeliveryProposalFormLayout } from "../../../../../../widgets/delivery-proposal-form-layout";
import type { AdminDeliveryProposalDetailPageProps } from "../../../../model";
import type { CreateDeliveryProposalFormSchemaType } from "../../../../model/validation";
import { DestinationForm } from "./destination-form";

export const DestinationsForm = (props: {
  control: Control<CreateDeliveryProposalFormSchemaType>;
  draftOfferCargo: AdminDeliveryProposalDetailPageProps["draftOfferCargo"];
}) => {
  const { draftOfferCargo, control } = props;
  const draftOfferCargoData = draftOfferCargo.data;
  const destinations = draftOfferCargo.data?.destinations;
  return (
    <DeliveryProposalFormLayout
      title={"配送スケジュール・ルート"}
      isLoading={!draftOfferCargo.data}
    >
      {destinations && draftOfferCargoData && (
        <Stack spacing={3} alignItems="stretch">
          <Controller
            name="loadingDestination"
            control={control}
            render={({ field, fieldState }) => {
              return (
                <DestinationForm
                  control={control}
                  taskContent="loading"
                  draftOfferCargo={draftOfferCargoData}
                  draftOfferCargoDestination={destinations[0]}
                  currentDeadlineValues={field.value}
                  errors={{
                    deadline: fieldState.error?.message,
                  }}
                  onChange={field.onChange}
                />
              );
            }}
          />
          {destinations.slice(1, -1).map((destination, index) => {
            return (
              <Controller
                key={destination.id}
                name={`transitDestinations.${index}`}
                control={control}
                render={({ field, fieldState }) => {
                  return (
                    <DestinationForm
                      control={control}
                      taskContent="transit"
                      draftOfferCargo={draftOfferCargoData}
                      draftOfferCargoDestination={destination}
                      currentDeadlineValues={field.value}
                      errors={{
                        deadline: fieldState.error?.message,
                      }}
                      onChange={field.onChange}
                    />
                  );
                }}
              />
            );
          })}
          <Controller
            name="unloadingDestination"
            control={control}
            render={({ field, fieldState }) => {
              return (
                <DestinationForm
                  control={control}
                  taskContent="unloading"
                  draftOfferCargo={draftOfferCargoData}
                  draftOfferCargoDestination={
                    destinations[destinations.length - 1]
                  }
                  currentDeadlineValues={field.value}
                  errors={{
                    deadline: fieldState.error?.message,
                  }}
                  onChange={field.onChange}
                />
              );
            }}
          />
        </Stack>
      )}
    </DeliveryProposalFormLayout>
  );
};
